/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Case_Age_TitleInputs */

const en_dashboard_case_age_title = /** @type {(inputs: Dashboard_Case_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open case age`)
};

const pt_br2_dashboard_case_age_title = /** @type {(inputs: Dashboard_Case_Age_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idade dos casos abertos`)
};

/**
* | output |
* | --- |
* | "Open case age" |
*
* @param {Dashboard_Case_Age_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_case_age_title = /** @type {((inputs?: Dashboard_Case_Age_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Case_Age_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_case_age_title(inputs)
	return pt_br2_dashboard_case_age_title(inputs)
});